import React from 'react';

import queryString from 'query-string';
import { FormattedMessage } from 'react-intl';
import { matchPath } from 'react-router-dom';
import { call, put, select } from 'redux-saga/effects';

import { getSavedFilingPeriodByIdRequest } from '@actions/savedFilingPeriod';
import { createGbSubmissionFailure, createGbSubmissionSuccess } from '@actions/submission';
import { createGbSubmission } from '@api/submission';
import { vfileRoutes } from '@routes';
import { requestFilesList } from '@store/filing/files/files.actions';
import { toastError } from '@store/notifications';
import { selectedStandardTemplateSelector } from '@store/selectors/standardTemplate';
import { submissionResponseSelector } from '@store/selectors/submission';

export const handleCreateGbSubmissionSaga = function* ({ payload }) {
  try {
    const selectedStandardTemplate = yield select(selectedStandardTemplateSelector);

    const response = yield call(createGbSubmission, selectedStandardTemplate.id);

    yield put(createGbSubmissionSuccess(response));

    // TODO: This part is not needed, we can get the info from response without fetching it from redux
    const submissionResponse = yield select(submissionResponseSelector);

    yield call(payload.onSuccess);

    // TODO: It looks like the redirectUrl logic is not used. HMRC redirects from their site to ours, so we don't get the URL back in a response. Leaving it in until it can be confirmed.
    if (submissionResponse.redirectUrl) {
      const redirectUrl = new URL(submissionResponse.redirectUrl);
      const { pathname } = redirectUrl;
      const match = matchPath(pathname, { path: vfileRoutes.FILING.rule });
      const error = queryString.parse(redirectUrl.search)?.error;

      // If we have an error in the query param and it is a filing URL, then toast the error instead of redirecting
      if (error) {
        yield put(
          toastError({
            message: error,
          })
        );
      } else if (match) {
        // Else refresh the filing. TODO: Also refresh uploads
        yield put(getSavedFilingPeriodByIdRequest(match.params?.filingPeriodId));
        yield put(requestFilesList());
      } else {
        // Or redirect for unknown URLs. Not clear if this is needed, just kept in case HMRC sends external URLs
        yield call(window.open, submissionResponse.redirectUrl, '_self');
      }
    }
  } catch (errors) {
    const { fieldErrors, nonFieldErrors } = errors.data || {};

    yield put([
      toastError({
        message: fieldErrors?.password ||
          fieldErrors?.certificate ||
          fieldErrors?.standardTemplateId ||
          fieldErrors?.submissionsId ||
          nonFieldErrors || (
            <FormattedMessage
              defaultMessage="An unexpected error occurred, please try again."
              id="global.notification.api-error-default"
            />
          ),
      }),
      createGbSubmissionFailure(errors),
    ]);
  }
};
